// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import StepExportController from "./step_export_controller"
application.register("step-export", StepExportController)
